// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "strong>small{display:block;font-weight:400}aside{width:calc(100% - 1rem)}aside>.clearall{opacity:0;cursor:pointer;transition:opacity .1s ease}aside:hover>.clearall{opacity:.8}aside strong{--tw-text-opacity:1;color:rgba(255, 255, 255, var(--tw-text-opacity))}aside a{--tw-text-opacity:1;color:rgba(239, 246, 255, var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
